<template>
  <div class>
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>
        <v-icon class="icon">fa-pencil-alt</v-icon>Edit Customer
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small @click="closePanel" :color="this.$gf.headerColor()">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-form>
            <v-text-field
              :error-messages="messages.first_name"
              v-model="user.first_name"
              label="First Name"
              type="text"
              filled
            ></v-text-field>
            <v-text-field
              :error-messages="messages.last_name"
              v-model="user.last_name"
              label="Last Name"
              type="text"
              filled
            ></v-text-field>
            <v-text-field
              :error-messages="messages.company_name"
              v-model="user.company_name"
              label="Company Name"
              type="text"
              filled
            ></v-text-field>
            <v-text-field
              :error-messages="messages.email"
              v-model="user.email"
              label="Email"
              type="text"
              filled
            ></v-text-field>
            <v-select
              :items="noOfEmployeesOptions"
              v-model="user.banding"
              item-value="id"
              item-text="name"
              label="Number of Users"
              attach
              filled
              hide-no-data :loading="bandingLoading"
              :disabled="$globalConfig.APP_NAME === 'partner'"
            >
            <template #progress>
                <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
            </template>
          </v-select>
            <v-select
              v-model="user.managers"
              :items="accountManagerList"
              item-text="full_name"
              item-value="id"
              label="Assign Manager"
              class="mt-4"
              :menu-props="{ maxHeight: '400' }"
              attach
              filled
              multiple
              v-if="$globalConfig.APP_NAME === 'partner' && this.$store.getters.level != 5"
            ></v-select>
            <!-- <drop-zone
              :type="type"
              :accepted="accepted"
              :image.sync="company_logo"
              class="mt-5"
              text="Click here to upload Customer Logo (155 x 33)"
            ></drop-zone>
             <p class="block text-left mt-4 caption">
              Max upload filesize: 1MB <br />
              Dimension should be 155 x 33<br />
              Accepted file formats: png, jpg
            </p> -->
            <CompanyLogoUpload 
                :image.sync="company_logo"
                class="mt-5 mb-5"
                text="Click here to upload Customer Logo"
                :type="'company-logo'"
                :accepted="'image/jpg,image/jpeg,image/png'"
                :dropzone-id="'profile_image'"
              />
              <p class="block text-left mt-4 caption">
                Max upload filesize: 1MB<br />
                Recommended Dimensions: 475 × 115<br />
                Accepted formats: PNG, JPG
              </p>
              <!-- Theme Color Picker -->
            <v-row align="center" v-if="user.theme_color && user.allow_theme_customization" class="mt-2 mb-2">
                <v-col cols="12" sm="4">
                  <v-text-field v-model="user.theme_color.primary" label="Theme Colour" class="color-input" hide-details
                    dense filled readonly>
                    <template v-slot:append>
                      <v-menu v-model="menuButton" :close-on-content-click="false" offset-y transition="scale-transition" max-width="290"
                        min-width="290">
                        <template v-slot:activator="{ on, attrs }">
                          <v-avatar v-bind="attrs" v-on="on" size="24"
                            :style="{ backgroundColor: user.theme_color.primary, cursor: 'pointer', border : '1px solid'}"
                            class="color-circle"></v-avatar>
                        </template>

                        <v-card>
                          <v-color-picker v-model="user.theme_color.primary" hide-mode-switch flat
                            mode="hexa"></v-color-picker>
                        </v-card>
                      </v-menu>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-btn v-on="on" outlined small
                      color="secondary" @click="resetToDefaultColor" title="Reset to Default Color">
                      <v-icon small>fa-arrows-rotate</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="4" >
                  <v-btn :style="{ backgroundColor: user.theme_color.primary, color: '#fff' }" elevation="2">
                    Example Button
                  </v-btn>
                </v-col>
              </v-row>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn
          v-if="!s3Uploading"
          color="primary"
          class="mr-1"
          @click="closePanel"
          >Cancel</v-btn
        >
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="primary" @click="updateUser">Save</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import userAPI from '@/api/user.js';
// import DropZone from '@/components/global/Dropzone';
import CompanyLogoUpload from "@/components/global/CompanyLogoUpload";
import companyAPI from '@/api/company.js';

export default {
  name: 'Edituser',
  components: {
    // DropZone,
    CompanyLogoUpload
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    params: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      type: 'company-logo',
      accepted: 'image/jpg,image/jpeg,image/png',
      accountManagerList: [],
      messages: {},
      user: {},
      groups: [],
      valid: true,
      successMessage: 'Customer Successfully Updated.',
      errorMessage:
        'Oops, something went wrong! Please check information is correct.',
      noOfEmployeesOptions: [],
      waitMessage: 'Please wait, we are uploading your image.',
      loading: false,
      bandingLoading: false,
      menuButton: false,
      menuText: false,
    };
  },
  computed: {
    company_logo() {
      return this.user.hasOwnProperty('company_avatar') &&
        this.user.company_avatar != ''
        ? this.user.company_avatar.url
        : null;
    },
    s3Uploading() {
      //if(this.user.company_logo.url !=undefined) {
      return this.$store.getters.s3Uploading;
      //}
    },
    showEmpOption2() {
      if (
        this.id == 'qnwmkv57d05blag6' ||
        this.user.partner_id == 'qnwmkv57d05blag6' ||
        this.id == 'xeml73oyko4d9qbr' ||
        this.user.partner_id == 'xeml73oyko4d9qbr'
      ) {
        return true;
      } else {
        return false;
      }
    },
    selectedManager() {
      return this.user.managers.data.map((x) => {
        return x.id;
      });
    },
  },
  mounted() {
    this.$store.dispatch('setS3Uploading', false);
    this.getUser(this.id);
    if(this.$globalConfig.APP_NAME === 'partner'){
      this.getAccountManagerList();
      this.getBandings();
    }
  },
  methods: {
    closePanel() {
      this.$emit('closePanel', {});
    },
    changeConfirmation() {
      this.$snotify.confirm(this.changeRole, {
        backdrop:0.3,                        
        buttons: [
          {
            text: 'OK',
            className: 'toast-continue-button',
            action: (toast) => this.contine(toast),
          },
        ],
      });
    },
    contine(toast) {
      this.$snotify.remove(toast.id);
    },
    getUser(id) {
      userAPI.getUser(id, '?include=groups,managers').then((response) => {
        this.user = response.data.data;
        this.user.managers = this.selectedManager;
        this.$store.dispatch('setDropzoneLoaded', { id: 'profile_image', value: true });
      });
    },
    updateUser() {
      this.loading = true;

      if (this.$store.getters.fileDetails.name != this.user.company_logo.entity && this.$store.getters.s3Url != '') {
        this.$snotify.info(this.waitMessage);
      }
      this.user.manager_id = this.user.managers;
      userAPI
        //.updateUser(this.id, this.user)
        .updateOwner(
          this.id,
          this.user,
          this.$store.getters.s3Url,
          this.$store.getters.fileDetails
        )
        .then(() => {
          this.$store.dispatch('profile');
          this.closePanel();
          EventBus.$emit('USERS_UPDATED', this.params);
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch((err) => {
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    getAccountManagerList() {
      userAPI.getManagers(this.$store.getters.user.id).then((response) => {
        this.accountManagerList = response.data.data;
      });
    },
    getBandings(){
      this.bandingLoading = true;
      companyAPI
        .getPartnerBandings()
        .then((res) => {
          this.bandingLoading = false;
          this.noOfEmployeesOptions = Object.values(res.data.banding);
        });
    },
    resetToDefaultColor(){
        this.user.theme_color.primary = process.env.VUE_APP_PRIMARY_COLOR;
    },
  },
};
</script>
<style scoped>
.v-progress-circular{
    height: auto !important;
}
</style>